import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomPhoneInput from "../../../CustomControls/CustomPhoneInput";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomMultiSelect from "../../../CustomControls/CustomMultiSelect";
import swal from "sweetalert";
import img200 from "../../../../images/avatar/DefaultUserPhoto.jpg";
import { SVGICON } from "../../../constant/theme";
import {
  capitalizeString,
  delete_RecordWithoutApi,
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";

import { post, postFormData } from "../../../helpers/api_helper";
import {
  POST_GetEmployeeDDLList,
  POST_GetMachineCalibrationDetailByID,
  POST_GetMachineCalibrationDetailByMachineID,
  POST_GetMachinesDropDownList,
  POST_MachineCalibrationInsert,
  POST_MachineCalibrationUpdate,
} from "../../../helpers/url_helper";
import moment from "moment/moment";

const AddMachinesCalibration = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const [machineOptions, setMachineOptions] = useState([]);
  const [maintanceByOptions, setMaintanceByOptions] = useState([]);
  const [showAdditionalDocumentsModal, setShowAdditionalDocumentsModal] =
    useState(false);
  const [showCertificateModal, setShowCertificateModal] = useState(false);

  const validationSchema = Yup.object().shape({
    MachineIDEncrypt: Yup.string().trim().required("Machine is required field"),
    MaintenanceDate: Yup.string()
      .trim()
      .required("Maintenance Date is required field"),
    CalibrationDate: Yup.string()
      .trim()
      .required("Calibration Date is required field"),
    Agency: Yup.string().trim().required("Agency is required field"),
    MaintanceByEncrypt: Yup.string()
      .trim()
      .required("Maintance By is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      MachineCalibrationIDEncrypt: PrimaryIdParam
        ? window.atob(PrimaryIdParam)
        : "",
      MachineIDEncrypt: "",
      MachineName: "",
      MaintenanceDate: new Date(),
      CalibrationDate: new Date(),
      MaintanceByEncrypt: "",
      Description: "",
      Agency: "",
      PreventiveAction: "",
      Remarks: "",
      ListOfMachineCalibrationDocuments: [],
      ListOfMachinesCalibration: [],
      ListOfMachineCalibrationCertificate: [],
      ListOfMachineCalibrationAdditionalDocuments: [],
    },
    validateOnBlur: false,
  });

  const {
    values: {
      MachineCalibrationIDEncrypt,
      MachineIDEncrypt,
      MachineName,
      MaintenanceDate,
      CalibrationDate,
      MaintanceByEncrypt,
      Description,
      Agency,
      PreventiveAction,
      Remarks,
      ListOfMachinesCalibration,
      ListOfMachineCalibrationDocuments,
      ListOfMachineCalibrationCertificate,
      ListOfMachineCalibrationAdditionalDocuments,
    },
  } = formik;

  useEffect(() => {
    if (!MaintenanceDate) {
      formik.setFieldValue("MaintenanceDate", "");
    }
    if (!CalibrationDate) {
      formik.setFieldValue("CalibrationDate", "");
    }
  }, [MaintenanceDate, CalibrationDate]);

  const handleValidSubmit = (values) => {
    setIsLoading(true);

    let formData = new FormData();

    formData.append(
      "MachineCalibrationIDEncrypt",
      values?.MachineCalibrationIDEncrypt
    );
    formData.append("MachineIDEncrypt", MachineIDEncrypt);
    formData.append(
      "MaintenanceDate",
      values?.MaintenanceDate
        ? moment(values?.MaintenanceDate)
            .format("YYYY-MM-DD")
            .replace(/^\-/, "")
        : ""
    );
    formData.append(
      "CalibrationDate",
      values?.CalibrationDate
        ? moment(values?.CalibrationDate)
            .format("YYYY-MM-DD")
            .replace(/^\-/, "")
        : ""
    );
    formData.append(
      "Description",
      values?.Description ? values?.Description : ""
    );

    formData.append("Agency", values?.Agency ? values?.Agency : "");
    formData.append(
      "PreventiveAction",
      values?.PreventiveAction ? values?.PreventiveAction : ""
    );
    formData.append("MaintanceByEncrypt", values?.MaintanceByEncrypt);
    formData.append("Remarks", values?.Remarks ? values?.Remarks : "");

    formData.append("CompanyIDEncrypt", AuthUser?.CompanyIDEncrypt);
    formData.append("BranchIDEncrypt", AuthUser?.BranchIDEncrypt);

    formData.append(
      "CreatedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
    );
    formData.append(
      "ModifiedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
    );

    Promise.all(
      values?.ListOfMachineCalibrationDocuments?.map((x, i) => {
        formData.append(
          `ListOfMachineCalibrationDoc[${i}].MachineCalibrationDocumentsIDEncrypted`,
          x?.MachineCalibrationDocumentsIDEncrypted
        );
        formData.append(
          `ListOfMachineCalibrationDoc[${i}].MachineCalibrationIDEncrypted`,
          x?.MachineCalibrationIDEncrypted
        );
        formData.append(
          `ListOfMachineCalibrationDoc[${i}].DocumentsType`,
          x?.DocumentsType
        );
        formData.append(
          `ListOfMachineCalibrationDoc[${i}].MachineCalibrationDocumentFile`,
          x?.MachineCalibrationDocumentFile
        );
        formData.append(
          `ListOfMachineCalibrationDoc[${i}].MachineCalibrationDocumentPath`,
          x?.MachineCalibrationDocumentPath
        );

        formData.append(
          `ListOfMachineCalibrationDoc[${i}].IsDeleted`,
          x?.IsDeleted
        );
      })
    );
    console.log("Save", values);

    // return;

    postFormData(
      PrimaryIdParam
        ? POST_MachineCalibrationUpdate
        : POST_MachineCalibrationInsert,
      formData
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/machines-calibration");
          }, 1000);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getMachinesDDL();
    getMaintanceByDDL();
    if (PrimaryIdParam) {
      GetMachineCalibrationDetail();
    }
  }, []);

  const GetMachineCalibrationDetail = () => {
    setIsLoading(true);
    post(POST_GetMachineCalibrationDetailByID, {
      MachineCalibrationIDEncrypt: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "MaintenanceDate",
            response?.MaintenanceDate
              ? new Date(response?.MaintenanceDate)
              : new Date()
          );
          formik.setFieldValue(
            "CalibrationDate",
            response?.CalibrationDate
              ? new Date(response?.CalibrationDate)
              : new Date()
          );

          formik.setFieldValue("MachineName", response?.MachineName);
          formik.setFieldValue("MachineIDEncrypt", response?.MachineIDEncrypt);
          formik.setFieldValue(
            "MaintanceByEncrypt",
            response?.MaintanceByEncrypt
          );
          formik.setFieldValue("Description", response?.Description);
          formik.setFieldValue("Agency", response?.Agency);
          formik.setFieldValue("PreventiveAction", response?.PreventiveAction);
          formik.setFieldValue("Remarks", response?.Remarks);
          formik.setFieldValue(
            "MachineCalibrationIDEncrypt",
            response?.MachineCalibrationIDEncrypt
          );

          formik.setFieldValue(
            "ListOfMachineCalibrationDocuments",
            response?.ListOfMachineCalibrationDocuments?.map((x) => ({
              ...x,
              DocumentsType: x?.DocumentsType,
              MachineCalibrationDocumentsIDEncrypted:
                x?.MachineCalibrationDocumentsIDEncrypt,
              MachineCalibrationIDEncrypted: x?.MachineCalibrationIDEncrypt,
              IsDeleted: false,
            }))
          );

          formik.setFieldValue(
            "ListOfMachineCalibrationCertificate",
            response?.ListOfMachineCalibrationDocuments?.filter(
              (x) => x.DocumentsType == 1
            ).map((x) => ({
              ...x,
              DocumentsType: x?.DocumentsType,
              MachineCalibrationDocumentsIDEncrypted:
                x?.MachineCalibrationDocumentsIDEncrypt,
              MachineCalibrationIDEncrypted: x?.MachineCalibrationIDEncrypt,
              IsDeleted: false,
            }))
          );

          formik.setFieldValue(
            "ListOfMachineCalibrationAdditionalDocuments",
            response?.ListOfMachineCalibrationDocuments?.filter(
              (x) => x.DocumentsType == 2
            ).map((x) => ({
              ...x,
              DocumentsType: x?.DocumentsType,
              MachineCalibrationDocumentsIDEncrypted:
                x?.MachineCalibrationDocumentsIDEncrypt,
              MachineCalibrationIDEncrypted: x?.MachineCalibrationIDEncrypt,
              IsDeleted: false,
            }))
          );

          getMachinesCalibrationHistory(response?.MachineIDEncrypt);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getMachinesDDL = () => {
    setIsLoading(true);
    post(POST_GetMachinesDropDownList, {
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setMachineOptions(
            response?.MachinesDropDownList?.filter(
              (x) => x.IsCalibrationValidity == true
            )?.map((item) => ({
              label: item.MachineName,
              value: item.MachineIDEncrypt,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getMaintanceByDDL = async () => {
    setIsLoading(true);
    await post(POST_GetEmployeeDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      UserType: AuthUser?.UserType,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setMaintanceByOptions(
            response?.EmployeeList?.map((item) => ({
              label: item.EmployeeName,
              value: item.EmployeeIDEncrypted,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const uploadCertificate = (e) => {
    if (e?.target?.files[0]) {
      const file = e?.target?.files[0];
      //var pattern = /(.png|.gif|.jpeg|.jpg|pdf)$/;
      //if (!file.type.match(pattern)) {
      if (!file) {
        warningMessage("Select valid file!");
      } else {
        formik.setFieldValue("ListOfMachineCalibrationDocuments", [
          ...ListOfMachineCalibrationDocuments,
          {
            MachineCalibrationDocumentsIDEncrypted: "",
            MachineCalibrationIDEncrypted: "",
            DocumentsType: 1,
            MachineCalibrationDocumentFile: file,
            viewFile: URL.createObjectURL(file),
            MachineCalibrationDocumentFileName: file?.name,
            MachineCalibrationDocumentPath: "",
            IsDeleted: false,
          },
        ]);

        formik.setFieldValue("ListOfMachineCalibrationCertificate", [
          ...ListOfMachineCalibrationCertificate,
          {
            MachineCalibrationDocumentsIDEncrypted: "",
            MachineCalibrationIDEncrypted: "",
            DocumentsType: 1,
            MachineCalibrationDocumentFile: file,
            viewFile: URL.createObjectURL(file),
            MachineCalibrationDocumentFileName: file?.name,
            MachineCalibrationDocumentPath: "",
            IsDeleted: false,
          },
        ]);
      }
    }
  };

  const uploadAdditionalDocuments = (e) => {
    if (e?.target?.files[0]) {
      const file = e?.target?.files[0];
      // var pattern = /(.png|.gif|.jpeg|.jpg|pdf)$/;
      //if (!file.type.match(pattern)) {
      if (!file) {
        warningMessage("Select valid file!");
      } else {
        formik.setFieldValue("ListOfMachineCalibrationDocuments", [
          ...ListOfMachineCalibrationDocuments,
          {
            MachineCalibrationDocumentsIDEncrypted: "",
            MachineCalibrationIDEncrypted: "",
            DocumentsType: 2,
            MachineCalibrationDocumentFile: file,
            viewFile: URL.createObjectURL(file),
            MachineCalibrationDocumentFileName: file?.name,
            MachineCalibrationDocumentPath: "",
            IsDeleted: false,
          },
        ]);

        formik.setFieldValue("ListOfMachineCalibrationAdditionalDocuments", [
          ...ListOfMachineCalibrationAdditionalDocuments,
          {
            MachineCalibrationDocumentsIDEncrypted: "",
            MachineCalibrationIDEncrypted: "",
            DocumentsType: 2,
            MachineCalibrationDocumentFile: file,
            viewFile: URL.createObjectURL(file),
            MachineCalibrationDocumentFileName: file?.name,
            MachineCalibrationDocumentPath: "",
            IsDeleted: false,
          },
        ]);
      }
    }
  };

  const deleteMachineCalibrationDocuments = (i, subIdx, id) => {
    formik.setFieldValue(
      "ListOfMachineCalibrationCertificate",
      ListOfMachineCalibrationCertificate?.map((x, idx) => {
        if (idx == i) {
          return {
            ...x,
            IsDeleted: true,
          };
        } else {
          return { ...x };
        }
      })
    );

    formik.setFieldValue(
      "ListOfMachineCalibrationDocuments",
      ListOfMachineCalibrationCertificate?.map((x, idx) => {
        if (idx == i && id == "") {
          return {
            ...x,
            IsDeleted: true,
          };
        } else {
          return { ...x };
        }
      })
    );

    if (id) {
      formik.setFieldValue(
        "ListOfMachineCalibrationDocuments",
        ListOfMachineCalibrationCertificate?.map((x, idx) => {
          if (x?.MachineCalibrationDocumentsIDEncrypted == id) {
            return {
              ...x,
              IsDeleted: true,
            };
          } else {
            return { ...x };
          }
        })
      );
    }
  };

  const deleteMachineCalibrationAddDocuments = (i, subIndx, id) => {
    formik.setFieldValue(
      "ListOfMachineCalibrationAdditionalDocuments",
      ListOfMachineCalibrationAdditionalDocuments?.map((x, idx) => {
        if (idx == i) {
          return {
            ...x,
            IsDeleted: true,
          };
        } else {
          return { ...x };
        }
      })
    );

    formik.setFieldValue(
      "ListOfMachineCalibrationDocuments",
      ListOfMachineCalibrationAdditionalDocuments?.map((x, idx) => {
        if (idx == i && id == "") {
          return {
            ...x,
            IsDeleted: true,
          };
        } else {
          return { ...x };
        }
      })
    );

    if (id) {
      formik.setFieldValue(
        "ListOfMachineCalibrationDocuments",
        ListOfMachineCalibrationAdditionalDocuments?.map((x, idx) => {
          if (x?.MachineCalibrationDocumentsIDEncrypted == id) {
            return {
              ...x,
              IsDeleted: true,
            };
          } else {
            return { ...x };
          }
        })
      );
    }
  };

  const handleChangeMachine = (e) => {
    formik.setFieldValue("MachineIDEncrypt", e?.value ?? "");
    getMachinesCalibrationHistory(e?.value ?? "");
  };

  const getMachinesCalibrationHistory = (mid) => {
    setIsLoading(true);

    post(POST_GetMachineCalibrationDetailByMachineID, {
      MachineIDEncrypt: mid,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ListOfMachinesCalibration",
            response?.ListOfMachineCalibration?.map((x) => ({
              MachineCalibrationIDEncrypt: x?.MachineCalibrationIDEncrypt,
              MachineIDEncrypt: x?.MachineIDEncrypt,
              MachineName: x?.MachineName,
              MaintenanceDate: x?.MaintenanceDate,
              CalibrationDate: x?.CalibrationDate,
              MaintanceBy: x?.MaintanceBy,
              Agency: x?.Agency,
              Description: x?.Description,
              PreventiveAction: x?.PreventiveAction,
              Remarks: x?.Remarks,
              CalibrationValidity: x?.CalibrationValidity,
            }))
          );
        } else {
          formik.setValues("ListOfMachinesCalibration", []);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">
              {PrimaryIdParam ? "Edit" : "Add"} Machines Calibration
            </h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={6}>
                    <div className="card mb-2" style={{ height: "auto" }}>
                      <div className="card-body p-2">
                        <Row>
                          <Col lg={6}>
                            {PrimaryIdParam ? (
                              <Field
                                label="Machine Name"
                                name="MachineName"
                                component={CustomInput}
                                maxLength={100}
                                disabled={true}
                              />
                            ) : (
                              <Field
                                label="Machine"
                                name="MachineIDEncrypt"
                                placeholder={"Select Machine"}
                                component={CustomSelect}
                                options={machineOptions}
                                required
                                onChange={handleChangeMachine}
                                autoFocus
                              />
                            )}
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Maintenance Date"
                              name="MaintenanceDate"
                              placeholder={"Select Maintenance Date"}
                              component={CustomFlatpickr}
                              required
                              options={{
                                altInput: true,
                                altFormat: "j-M-Y",
                                dateFormat: "d-m-Y",
                              }}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Maintance By"
                              name="MaintanceByEncrypt"
                              placeholder={"Select Maintance By"}
                              component={CustomSelect}
                              options={maintanceByOptions}
                              isClearable={false}
                              required
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Calibration Date"
                              name="CalibrationDate"
                              placeholder={"Select Calibration Date"}
                              component={CustomFlatpickr}
                              required
                              options={{
                                altInput: true,
                                altFormat: "j-M-Y",
                                dateFormat: "d-m-Y",
                              }}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Agency"
                              name="Agency"
                              placeholder={"Enter Agency"}
                              component={CustomInput}
                              maxLength={500}
                              required
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "Agency",
                                  capitalizeString(e)
                                );
                              }}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Description"
                              name="Description"
                              placeholder={"Enter Description"}
                              component={CustomInput}
                              maxLength={500}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "Description",
                                  capitalizeString(e)
                                );
                              }}
                            />
                          </Col>

                          <Col lg={6}>
                            <div className="mb-2">
                              <label className="mb-1">Certificate</label>
                              <div className="input-group">
                                <span className="form-control form-control-sm ps-2">
                                  <Link
                                    to="#"
                                    className="text-primary"
                                    onClick={() => {
                                      setShowCertificateModal(true);
                                    }}
                                  >
                                    View Certificate
                                  </Link>
                                </span>
                                <div
                                  className="input-group-text"
                                  title="Choose File"
                                  style={{
                                    borderRadius: "0 0.375rem 0.375rem 0",
                                  }}
                                >
                                  <div className="open-file">
                                    <input
                                      type="file"
                                      id="CertificateUpload"
                                      onChange={uploadCertificate}
                                    />
                                    <label
                                      htmlFor="CertificateUpload"
                                      name=""
                                    ></label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div className="mb-2">
                              <label className="mb-1">
                                Additional Documents
                              </label>
                              <div className="input-group">
                                <span className="form-control form-control-sm ps-2">
                                  <Link
                                    to="#"
                                    className="text-primary"
                                    onClick={() => {
                                      setShowAdditionalDocumentsModal(true);
                                    }}
                                  >
                                    View Additional Documents
                                  </Link>
                                </span>

                                <div
                                  className="input-group-text"
                                  title="Choose File"
                                  style={{
                                    borderRadius: "0 0.375rem 0.375rem 0",
                                  }}
                                >
                                  <div className="open-file">
                                    <input
                                      type="file"
                                      id="AdditionalDocumentsUpload"
                                      onChange={uploadAdditionalDocuments}
                                    />
                                    <label
                                      htmlFor="AdditionalDocumentsUpload"
                                      name=""
                                    ></label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Col>

                          <Col lg={6}>
                            <Field
                              label="Preventive Action"
                              name="PreventiveAction"
                              placeholder={"Enter Preventive Action"}
                              component={CustomTextArea}
                              rows={3}
                              maxLength={500}
                            />
                          </Col>

                          <Col lg={6}>
                            <Field
                              label="Remarks"
                              name="Remarks"
                              placeholder={"Enter Remarks"}
                              component={CustomTextArea}
                              rows={3}
                              maxLength={500}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <Row>
                      <Col lg={12}>
                        <div className="card mb-2" style={{ height: "auto" }}>
                          <div className="card-body p-2">
                            <div className="d-flex  mb-1"></div>
                            <div className="table-responsive active-projects style-1 shorting">
                              <div
                                id="MachinesCalibration-tbl_wrapper"
                                className="dataTables_wrapper no-footer"
                              >
                                <table
                                  id="MachinesCalibration-tbl"
                                  className="table dataTable no-footer mb-0"
                                >
                                  <thead>
                                    <tr>
                                      <th width="5%"></th>
                                      <th width="20%">Maintenance Date</th>
                                      <th width="20%">Calibration Date</th>
                                      <th width="25%">Maintance By</th>
                                      <th
                                        width="30%"
                                        style={{ textAlign: "left" }}
                                      >
                                        Agency
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {ListOfMachinesCalibration?.length > 0 ? (
                                      ListOfMachinesCalibration?.map(
                                        (item, indxMP) => (
                                          <tr key={indxMP}>
                                            <td>{indxMP + 1}</td>
                                            <td> {item.MaintenanceDate}</td>
                                            <td> {item.CalibrationDate}</td>
                                            {/* <td> {item.MaintanceBy}</td> */}
                                            <td
                                              style={{
                                                cursor: "pointer",
                                                textAlign: "left",
                                              }}
                                              className="popupOverlay"
                                            >
                                              <OverlayTrigger
                                                trigger={["hover", "focus"]}
                                                key={indxMP}
                                                responsive={true}
                                                overlay={
                                                  <Tooltip className="toltip-popover">
                                                    <strong className="p-1">
                                                      {item.MaintanceBy}
                                                    </strong>
                                                  </Tooltip>
                                                }
                                              >
                                                <span>{item.MaintanceBy}</span>
                                              </OverlayTrigger>
                                            </td>
                                            <td
                                              style={{
                                                cursor: "pointer",
                                                textAlign: "left",
                                              }}
                                              className="popupOverlay"
                                            >
                                              <OverlayTrigger
                                                trigger={["hover", "focus"]}
                                                key={indxMP}
                                                responsive={true}
                                                overlay={
                                                  <Tooltip className="toltip-popover">
                                                    <strong className="p-1">
                                                      {item.Agency}
                                                    </strong>
                                                  </Tooltip>
                                                }
                                              >
                                                <span>{item.Agency}</span>
                                              </OverlayTrigger>
                                            </td>
                                            {/* <td style={{ textAlign: "left" }}>
                                              {item.Agency}
                                            </td> */}
                                          </tr>
                                        )
                                      )
                                    ) : (
                                      <tr>
                                        <td
                                          colSpan={5}
                                          style={{ textAlign: "left" }}
                                        >
                                          <div>{"No Record Found..."}</div>
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <hr className="mt-1 mb-2"></hr>
                <button
                  type="submit"
                  // className="btn btn-primary"
                  className="btn btn-primary btn-sm me-2"
                >
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </button>
                <button
                  type="button"
                  // className="btn btn-danger light"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
        <Modal
          className="fade"
          show={showCertificateModal}
          onHide={setShowCertificateModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Certificate</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowCertificateModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div style={{ float: "right", marginRight: "2rem" }}>
                    + Add
                    <div
                      className="open-file mt-2"
                      style={{ marginLeft: "2rem" }}
                    >
                      <input
                        type="file"
                        id="CertificateUpload2"
                        //accept="image/png, image/gif, image/jpeg"
                        onChange={uploadCertificate}
                      />
                      <label htmlFor="CertificateUpload2" name=""></label>
                    </div>
                  </div>
                </Col>

                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="CertificateImages-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="CertificateImages-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="4%"></th>
                            <th width="96%" style={{ textAlign: "left" }}>
                              Certificate Preview
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfMachineCalibrationCertificate?.filter(
                            (x) => x.IsDeleted == false && x.DocumentsType == 1
                          ).length > 0 ? (
                            ListOfMachineCalibrationCertificate?.filter(
                              (x) => x.DocumentsType == 1
                            ).map((item, indx) => (
                              <tr
                                key={indx}
                                style={{
                                  display:
                                    item?.IsDeleted == true ? "none" : "",
                                }}
                              >
                                <td>
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="View"
                                    onClick={() => {
                                      window.open(
                                        item.MachineCalibrationDocumentPath
                                          ? item.MachineCalibrationDocumentPath
                                          : item.viewFile,
                                        "_blank"
                                      );
                                    }}
                                  >
                                    <i className="fa fa-eye"></i>
                                  </Link>

                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-danger-light"
                                    className="icon-box icon-box-md me-1"
                                    title="Delete"
                                    onClick={() => {
                                      delete_RecordWithoutApi(
                                        deleteMachineCalibrationDocuments,
                                        indx,
                                        -1,
                                        item?.MachineCalibrationDocumentsIDEncrypted
                                      );
                                    }}
                                    // onClick={() => {
                                    //   deleteMachineCalibrationDocuments(
                                    //     indx,
                                    //     item?.MachineCalibrationDocumentsIDEncrypted
                                    //   );
                                    // }}
                                  >
                                    {SVGICON.DeleteDanger}
                                  </Link>
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {item.MachineCalibrationDocumentFileName}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={3} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowCertificateModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>

        <Modal
          className="fade"
          show={showAdditionalDocumentsModal}
          onHide={setShowAdditionalDocumentsModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Additional Documents</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowAdditionalDocumentsModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div style={{ float: "right", marginRight: "2rem" }}>
                    + Add
                    <div
                      className="open-file mt-2"
                      style={{ marginLeft: "2rem" }}
                    >
                      <input
                        type="file"
                        id="AdditionalDocumentsUpload2"
                        //accept="image/png, image/gif, image/jpeg"
                        onChange={uploadAdditionalDocuments}
                      />
                      <label
                        htmlFor="AdditionalDocumentsUpload2"
                        name=""
                      ></label>
                    </div>
                  </div>
                </Col>

                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="AdditionalDocuments-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="AdditionalDocuments-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="4%"></th>
                            <th width="96%" style={{ textAlign: "left" }}>
                              Additional Documents Preview
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfMachineCalibrationAdditionalDocuments?.filter(
                            (x) => x.IsDeleted == false && x.DocumentsType == 2
                          ).length > 0 ? (
                            ListOfMachineCalibrationAdditionalDocuments?.filter(
                              (x) => x.DocumentsType == 2
                            ).map((item, indx) => (
                              <tr
                                key={indx}
                                style={{
                                  display:
                                    item?.IsDeleted == true ? "none" : "",
                                }}
                              >
                                <td>
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="View"
                                    onClick={() => {
                                      window.open(
                                        item.MachineCalibrationDocumentPath
                                          ? item.MachineCalibrationDocumentPath
                                          : item.viewFile,
                                        "_blank"
                                      );
                                    }}
                                  >
                                    <i className="fa fa-eye"></i>
                                  </Link>

                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-danger-light"
                                    className="icon-box icon-box-md me-1"
                                    title="Delete"
                                    onClick={() => {
                                      delete_RecordWithoutApi(
                                        deleteMachineCalibrationAddDocuments,
                                        indx,
                                        -1,
                                        item?.MachineCalibrationDocumentsIDEncrypted
                                      );
                                    }}

                                    // onClick={() => {
                                    //   deleteMachineCalibrationAddDocuments(
                                    //     indx,
                                    //     item?.MachineCalibrationDocumentsIDEncrypted
                                    //   );
                                    // }}
                                  >
                                    {SVGICON.DeleteDanger}
                                  </Link>
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {item.MachineCalibrationDocumentFileName}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={3} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowAdditionalDocumentsModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>
      </div>
    </div>
  );
};

export default AddMachinesCalibration;
